import _defineProperty from "/root/code/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/root/code/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect, useState, useCallback, useMemo } from "react";
import useSWR from "swr";
import { Text, InputDropdown, IconTick } from "@catchoftheday/cg-components";
import { getEncodedUrl } from "@catchoftheday/utilities";
import { fetcher } from "../../../api/index";
import MessageDropdown from "./MessageDropdown";
import { extractPostcodeAndSuburb, transformLocationDataArray, trackOpenWidget } from "./utils";
import { LOCATION_DROPDOWN_ENDPOINT, MINIMUM_INPUT_LENGTH, DROPDOWN_DATA_FETCH_ERROR, DROPDOWN_INVALID_INPUT_ERROR } from "./consts";
import { jsx as ___EmotionJSX } from "@emotion/react";

var DeliveryLocationInput = function DeliveryLocationInput(_ref) {
  var selectedLocation = _ref.selectedLocation,
      inputProps = _ref.inputProps,
      dropdownContainerProps = _ref.dropdownContainerProps,
      hideOnBlur = _ref.hideOnBlur,
      onItemHover = _ref.onItemHover,
      onItemSelected = _ref.onItemSelected,
      onDataFetch = _ref.onDataFetch,
      hideInput = _ref.hideInput;

  var _useState = useState(""),
      locationInput = _useState[0],
      setLocationInput = _useState[1];

  var _useState2 = useState(false),
      itemHovered = _useState2[0],
      setItemHovered = _useState2[1];

  var _useState3 = useState(false),
      dropdownOpened = _useState3[0],
      setDropdownOpened = _useState3[1];

  var _ref2 = inputProps || {},
      onBlur = _ref2.onBlur,
      otherInputProps = _objectWithoutProperties(_ref2, ["onBlur"]);

  var _useSWR = useSWR(locationInput.length >= MINIMUM_INPUT_LENGTH ? getEncodedUrl(LOCATION_DROPDOWN_ENDPOINT, extractPostcodeAndSuburb(locationInput)) : null, fetcher),
      dropdownDataResponse = _useSWR.data,
      dropdownDataError = _useSWR.error,
      isValidating = _useSWR.isValidating;

  var dropdownData = useMemo(function () {
    return dropdownDataResponse !== null && dropdownDataResponse !== void 0 && dropdownDataResponse.data && Array.isArray(dropdownDataResponse.data) ? transformLocationDataArray(dropdownDataResponse.data) : [];
  }, [dropdownDataResponse]);
  var isAtMinimumInput = locationInput.length >= MINIMUM_INPUT_LENGTH;
  var isInvalidInput = dropdownData.length === 0 && !dropdownDataError && isAtMinimumInput;
  var isServerError = dropdownDataError !== undefined && isAtMinimumInput;
  var showErrorDropdown = !isValidating && (isInvalidInput || isServerError);
  var showSelectedLocationDropdown = selectedLocation && locationInput.length === 0;
  var handleInputChange = useCallback(function (input) {
    return setLocationInput(input);
  }, []);
  var handleItemHover = useCallback(function (hovered) {
    setItemHovered(hovered);

    if (typeof onItemHover === "function") {
      onItemHover(hovered);
    }
  }, [setItemHovered, onItemHover]);
  var handleInputBlur = useCallback(function (event) {
    if (hideOnBlur && (!itemHovered || locationInput.length === 0) && typeof hideInput === "function") {
      hideInput();
    }

    if (typeof onBlur === "function") {
      onBlur(event);
    }
  }, [hideOnBlur, itemHovered, locationInput.length, hideInput, onBlur]);
  useEffect(function () {
    if (typeof onDataFetch === "function") {
      onDataFetch(dropdownData, locationInput.length);
    }

    if (!dropdownOpened && dropdownData.length > 0) {
      setDropdownOpened(true);
    }
  }, [dropdownData, locationInput.length, onDataFetch, dropdownOpened]);
  useEffect(function () {
    if (dropdownOpened) {
      trackOpenWidget();
    }
  }, [dropdownOpened]);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(InputDropdown, {
    data: dropdownData,
    onInputChange: handleInputChange,
    onItemSelected: onItemSelected,
    onItemHover: handleItemHover,
    inputProps: _objectSpread({
      p: "3px 7px",
      mt: "3px",
      fontSize: "14px",
      fontWeight: "light",
      lineHeight: "1em",
      borderRadius: "2px",
      borderBottomLeftRadius: showErrorDropdown || showSelectedLocationDropdown ? "0px" : undefined,
      borderBottomRightRadius: showErrorDropdown || showSelectedLocationDropdown ? "0px" : undefined,
      focusBorderColor: showErrorDropdown || showSelectedLocationDropdown ? "transparent" : undefined,
      hoverBorderColor: showErrorDropdown || showSelectedLocationDropdown ? "transparent" : undefined,
      placeholder: "Postcode or Suburb",
      placeholderFontSize: "xs",
      placeholderFontWeight: "light",
      autoFocus: true,
      value: locationInput,
      onBlur: handleInputBlur
    }, otherInputProps),
    dropdownContainerProps: _objectSpread({
      cursor: "pointer",
      textTransform: "capitalize"
    }, dropdownContainerProps)
  }), showSelectedLocationDropdown && ___EmotionJSX(MessageDropdown, null, ___EmotionJSX(Text, {
    m: "0px",
    pr: "5px",
    fontSize: "xs",
    width: "100%",
    textTransform: "capitalize"
  }, selectedLocation), ___EmotionJSX(IconTick, {
    width: "10px",
    height: "17px",
    "aria-hidden": "true"
  })), showErrorDropdown && ___EmotionJSX(MessageDropdown, {
    isError: true
  }, isInvalidInput ? DROPDOWN_INVALID_INPUT_ERROR : DROPDOWN_DATA_FETCH_ERROR));
};

export default DeliveryLocationInput;